import { render, staticRenderFns } from "./RegisterClient.vue?vue&type=template&id=b3f9a41e&"
import script from "./RegisterClient.vue?vue&type=script&lang=js&"
export * from "./RegisterClient.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterClient.vue
// module id = null
// module chunks = 